import { HTTP } from "./http";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-ai.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-ai.php";
}

const AI = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },
};

export { AI };
